import { Link } from "@/i18n/LocaleLink";
import { ArrowUpRight } from "lucide-react";
import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { JOURNAL_IMAGES, IMAGES, useContent } from "@/data/content";
import { useSeo } from "@/hooks/useSeo";

export default function Journal() {
  const { ui, journal } = useContent();
  useSeo({ ...ui.seo.journal, image: IMAGES.botanical });

  return (
    <main data-testid="journal-page">
      <PageHero eyebrow={ui.journalPage.heroEyebrow} title={ui.journalPage.heroTitle} image="/images/irida-casual.jpg" testid="journal-hero" />
      <section className="bg-cream py-24 lg:py-32">
        <div className="mx-auto max-w-7xl px-6 lg:px-10">
          <div className="space-y-20">
            {journal.map((p, i) => (
              <Reveal key={p.slug} delay={0.05}>
                <Link to={`/journal/${p.slug}`} data-testid={`journal-entry-${p.slug}`}
                  className="group grid items-center gap-10 lg:grid-cols-12">
                  <div className={`lg:col-span-5 ${i % 2 === 1 ? "lg:order-2" : ""}`}>
                    <div className="overflow-hidden">
                      <img loading="lazy" src={JOURNAL_IMAGES[p.slug]} alt={p.title} className="aspect-[4/3] w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105" />
                    </div>
                  </div>
                  <div className={`lg:col-span-6 ${i % 2 === 1 ? "lg:order-1" : "lg:col-start-7"}`}>
                    <p className="text-xs tracking-[0.25em] uppercase text-clay">{p.threshold} · {p.date} · {p.readTime}</p>
                    <h2 className="mt-4 font-serif text-3xl sm:text-4xl leading-tight text-ink group-hover:text-clay transition-colors duration-300">{p.title}</h2>
                    <p className="mt-4 text-base leading-relaxed text-soft">{p.excerpt}</p>
                    <span className="mt-6 inline-flex items-center gap-2 text-sm text-clay">
                      {ui.common.readEntry} <ArrowUpRight size={15} strokeWidth={1.5} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                    </span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
